const textLight = {
  primary: "#484748",
  secondary: "rgba(74, 70, 109, 0.54)",
  disabled: "rgba(74, 70, 109, 0.38)",
  hint: "rgba(74, 70, 109, 0.38)"
};

export const themeColors = {
  light: {
    palette: {
      type: "light",
      primary: {
        // main: "#039be5",
        main: "#4a4af9",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#09092d",
        contrastText: "#ffffff"
      },
      error: {
        main: "#e51b23",
        contrastText: textLight.primary
      },
      text: textLight
    }
  },
  dark: {
    palette: {
      type: "dark",
      primary: {
        main: "#4a4af9",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#09092d",
        contrastText: "#ffffff"
      },
      background: {
        paper: "#222A45",
        default: "#1a2038"
      }
    }
  },
  blue: {
    palette: {
      type: "light",
      primary: {
        main: "#3366FF",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#4a4af9",
        contrastText: textLight.primary
      },
      text: textLight
    }
  },
  white: {
    palette: {
      type: "light",
      primary: {
        main: "#ffffff",
        contrastText: textLight.primary
      },
      secondary: {
        main: "#4a4af9",
        contrastText: textLight.primary
      },
      text: textLight
    }
  },
  red: {
    palette: {
      type: "dark",
      primary: {
        main: "#e53935",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#4a4af9",
        contrastText: textLight.primary
      }
    }
  }
};
